import { render, staticRenderFns } from "./Evaluation-attempts-table.vue?vue&type=template&id=9cd0298e"
import script from "./Evaluation-attempts-table.vue?vue&type=script&lang=js"
export * from "./Evaluation-attempts-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports